<div class="dialog-root-container">

  <!-- HEADER -->
  <h1 mat-dialog-title class="no-margin">
    {{ titolo }}
    <mat-icon class="close-icon" (click)="onNoClick()">close</mat-icon>
  </h1>

    <!-- DETTAGLIO AREA -->

  <div class="dialog-scrollable-content" *ngIf="!creazione && !modifica">
    <div class="wrapper-content-box">
      <div class="content-box">
        <mat-list role="list">
          <mat-list-item>
            <strong class="caption">ID Area:</strong>
            <span class="grey noFloat">{{data.area.id}}</span>
          </mat-list-item>
          <mat-list-item>
            <strong class="caption">Descrizione:</strong>
            <span class="grey noFloat">{{data.area.descrizione}}</span>
          </mat-list-item>
          <mat-list-item>
            <strong class="caption">Stato:</strong>
            <span class="grey noFloat">{{data.area.statoArea.descrizione}}</span>
          </mat-list-item>
        </mat-list>
      </div>

      <div class="content-box">
        <mat-list role="list">
          <mat-list-item>
            <strong class="caption">Area SEP:</strong>
            <span class="grey noFloat">{{data.area.idAreaSep}}</span>
          </mat-list-item>
          <mat-list-item *ngIf="data.area.dataInizio">
            <strong class="caption">Data inizio:</strong>
            <span class="grey noFloat">{{data.area.dataInizio | date:'dd/MM/yyyy'}}</span>
          </mat-list-item>
          <mat-list-item *ngIf="data.area.dataFine">
            <strong class="caption">Data fine:</strong>
            <span class="grey noFloat">{{data.area.dataFine | date:'dd/MM/yyyy'}}</span>
          </mat-list-item>
        </mat-list>
      </div>
    </div> <!-- wrapper-content-box -->
  </div> <!-- dialog-scrollable-content -->

  <!-- FORM DI CREAZIONE / MODIFICA -->

 <div class="form-container" *ngIf="creazione || modifica">
  <form class="details-form">
    <mat-form-field class="half-width">
      <mat-label>ID:</mat-label>
      <input matInput placeholder="Placeholder" [value]="data.area.id ?? 'L\'id comparirà una volta salvata l\'area'" disabled>
    </mat-form-field>

    <mat-form-field class="half-width" appearance="fill">
      <mat-label>Descrizione*</mat-label>
      <input matInput placeholder="Descrizione" name="descrizioneArea" [(ngModel)]="data.area.descrizione">
    </mat-form-field>

    <mat-form-field class="half-width margin-right" appearance="fill">
      <mat-label>Stato*</mat-label>
      <mat-select name="statoArea" [(ngModel)]="data.area.statoArea.id" placeholder="Stato*" [disabled]="creazione" (selectionChange)="onStatoAreaChange($event)">
        <mat-option *ngFor="let item of data.statiAree" [value]="item.id">
          {{item.descrizione}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="half-width">
      <mat-label>Area SEP*</mat-label>
      <input type="number" min="0" matInput placeholder="Area SEP*"
             name="idAreaSep" [(ngModel)]="data.area.idAreaSep">
    </mat-form-field>
  </form>
 </div>

     <!-- TABELLA ASSOCIAZIONI -->
    <div class="associazioni-table" *ngIf="!creazione">

      <!-- HEADER TABELLA -->
      <div class="row header">
        <div class="cell label"></div>
        <div class="cell">BOZZA</div>
        <div class="cell">VALIDATI</div>
        <div class="cell">APPROVATI</div>
        <div class="cell">DECRETATI</div>
        <div class="cell">ARCHIVIATI</div>
      </div>

      <!-- PROFILI -->
      <div class="row">
        <div class="cell label">N° Profili Associati</div>
        <div class="cell">{{data.area.numeroAssociazioni.proposteBozza}}</div>
        <div class="cell">{{data.area.numeroAssociazioni.proposteValidate}}</div>
        <div class="cell">{{data.area.numeroAssociazioni.proposteApprovate}}</div>
        <div class="cell">{{data.area.numeroAssociazioni.proposteDecretate}}</div>
        <div class="cell">{{data.area.numeroAssociazioni.proposteArchiviate}}</div>
      </div>

      <!-- COMPETENZE -->
      <div class="row">
        <div class="cell label">N° Competenze Indipendenti</div>
        <div class="cell">{{data.area.numeroAssociazioni.competenzeBozza}}</div>
        <div class="cell">{{data.area.numeroAssociazioni.competenzeValidate}}</div>
        <div class="cell">{{data.area.numeroAssociazioni.competenzeApprovate}}</div>
        <div class="cell">{{data.area.numeroAssociazioni.competenzeDecretate}}</div>
        <div class="cell">{{data.area.numeroAssociazioni.competenzeArchiviate}}</div>
      </div>

    </div> <!-- associazioni-table -->



  <!-- FOOTER -->
  <div mat-dialog-actions class="dialog-footer">
    <button mat-fab extended class="searchbox-buttons close-button" (click)="onNoClick()">
      <mat-icon>close</mat-icon>Chiudi
    </button>
    <button mat-fab extended class="searchbox-buttons save-button" (click)="checkSalva()" *ngIf="creazione || modifica"
          [disabled]="!checkForm()">
    <mat-icon>save</mat-icon>Salva
  </button>
  </div>

</div> <!-- dialog-root-container -->